function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M7.37 22h9.25a4.87 4.87 0 004.87-4.87V8.37a4.87 4.87 0 00-4.87-4.87H7.37A4.87 4.87 0 002.5 8.37v8.75c0 2.7 2.18 4.88 4.87 4.88z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.29 6.29c-.42 0-.75-.34-.75-.75V2.75a.749.749 0 111.5 0v2.78c0 .42-.33.76-.75.76zm7.42 0c-.42 0-.75-.34-.75-.75V2.75a.749.749 0 111.5 0v2.78c0 .42-.33.76-.75.76zm-.93 7.42H7.36a.749.749 0 110-1.5h7.42a.749.749 0 110 1.5zM12 17.42H7.36a.749.749 0 110-1.5H12a.749.749 0 110 1.5z"
})));